import { clarify } from '@/domain/services/VueDataProvider';
import { getGlobal } from '@/lib/utils.js';

const defaultState = () => ({
	accountName: getGlobal('accountName'),
	countries: [],
	country: getGlobal('country'),
	phoneWithLeadingZeros: [],
	timezones: getGlobal('timezones') ? clarify(getGlobal('timezones')) : null,
	momentLocale: getGlobal('momentLocale'),
	momentDateFormat: getGlobal('momentDateFormat'),
	momentTimeFormat: getGlobal('momentTimeFormat'),
	supportedLanguages: getGlobal('supportedLanguages') ? clarify(getGlobal('supportedLanguages')) : [],
	preferredLanguage: getGlobal('preferredLanguage'),
	defaultLanguage: null,
	defaultTimezone: getGlobal('defaultTimezone'),
	currentBreadcrumb: getGlobal('currentBreadcrumb'),
	history: {},
	lastModifiedField: null,
	formulaFieldCompatibleTypes: getGlobal('formulaFieldCompatibleTypes')
		? clarify(getGlobal('formulaFieldCompatibleTypes'))
		: [],
	hyperFormulaLicense: getGlobal('hyperFormulaLicense') ? clarify(getGlobal('hyperFormulaLicense')) : 'gpl-v3',
	flashMessage: getGlobal('flashMessage') ? clarify(getGlobal('flashMessage')) : {},
	userSlug: null,
});

const state = defaultState();

export default state;
export { defaultState };
